export default __webpack_public_path__ + "static/media/TheClipNoSaraAllen.7cf73c75.mp4";